<template>
  <div class="g-header">
    <div class="w1200">
      <!-- <el-row>
    <el-col :span="24"> -->
      <div class="logo">
        <!-- <div class="img"><img src="../../../static/img/logo.png" /></div> -->
        <div class="biao">投标保证金电子保函服务平台</div>
        <!-- <span class="iconfont icon-home1"></span>  -->
        <!-- <div class="name">{{cmpname}}</div> -->
        <!-- <div class="name2">简化工程担保流程  助力企业减负</div>         -->
      </div>
      <!-- </el-col> -->
      <!-- <el-col :span="4">
      <ul class="menu">
        <li>
          <router-link tag='a' :to="'/dashboard'" >主界面</router-link>
        </li> -->
      <!-- <li>
          <router-link tag='a' :to="incmpid=='8'?'/workerorder':'/order'" >投标订单</router-link>
        </li>
         <li>
          <router-link tag='a' :to="'/workerorder'" >其他订单</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/user'" >账户信息</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/companyInfo'" >企业信息</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/faPiao'" >发票信息</router-link>
        </li>

      </ul>
    </el-col>

    <el-col :span="6"  class="user-info">
      <span class="user-name"><span class="iconfont el-icon-g-user yellowzi"></span>{{username}}</span>
      <router-link tag='a' :to="'/login'" >退出<i class="el-icon-right"></i></router-link> 
    </el-col> -->
      <!-- </el-row> -->
      <!-- <div class="menu"><router-link tag='a' :to="'/dianzibaohan'">用户中心</router-link></div> -->
       <div class="tels">
        <div class="teltu">
          <img src="../../../static/img/header_tel.png" />
        </div>
        <div class="tel">{{servicePhone}}</div><!--400-666-7151-->
      </div>
      <!-- <div class="weixins">
        <div class="weixin" @click="handlePreview(file.name)">
          <img src="../../../static/img/weixin.gif" style="cursor: pointer" @click="showMap(url)" /></div>
        <div class="addkefu">点击添加<br />人工客服</div>
      </div> -->
    </div>
    <!-- 查看照片 -->
    <!-- <el-dialog title="查看大图" append-to-body :visible.sync="dialogImage" width="500px">
      <div class="img_box">
        <img style="object-fit: cover;margin-auto;width:100%;" src="../../../static/img/weixin.png">
        </img>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
export default {
  name: 'Header',
  data: function() {
    return {
      username: '',
      cmpname: '保证金电子保函系统',
      incmpid: '',
      customerid: '',
      dialogImage: false,
      showUrl: '../../../static/img/weixin.png',
      url: '../../../static/img/weixin.png',
      imageHeight: '0px',
      imageWidth: '0px',
      servicePhone:''
    }
  },
  created() {
    // this.cmpname = utils.getcmpname()
    // this.username = auth.getusername();
    // this.username = 'administrator'
    // this.customerid=auth.getCustomerId();
    // this.incmpid=utils.geincmpid();
    // if(utils.verifyDate()){
      this.servicePhone = '400-666-7151'
    // }else{
    //   this.servicePhone = '15555519973'
    // }
  },
  methods: {
    showMap(url) {
      //  const img = new Image()
      //   img.src = url
      //   this.imageHeight = img.height + 40 + 'px'
      //   this.imageWidth = img.width + 40 + 'px'
      this.dialogImage = true
      // this.showUrl = url
    }
  }
}
</script>

<style  scoped>
.g-header {
  z-index: 1500;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #fff;
  /* box-shadow: 0 1px 2px #ccc; */
  position: relative;
}
.menu .router-link-active {
  font-weight: bold;
  color: #e3a720;
  border-bottom: 3px solid #e3a720;
}
.w1200 {
  position: relative;
}
.menu {
  position: absolute;
  right: 0px;
  top: 0px;
}
/deep/ .router-link {
  color: #e3a720;
}
.logo {
  display: inline-block;
  /* display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start; */
  text-align: left;
}
.logo .img {
  display: inline-block;
  height: 53px;
}
.logo .img img {
  width: 100%;
  height: 100%;
}
/* .logo .biao {
  font-size: 32px;
  color: #e3a720;
  font-family: 'Microsoft YaHei', 'Heiti SC';
  display: inline-block;
} */
.logo .biao {
  /* font-size: 32px;
  color: #e3a720; */
  font-family: 'Microsoft YaHei', 'Heiti SC';
  display: inline-block;
    font-size: 22px;
  color: #0b5394;padding: 12px 0 0 0px;font-weight: bold;
}

.logo .name2 {
  color: #1f55a5 !important;
  font-size: 20px;
  padding: 0px 0 0 10px;
  display: inline-block;
  vertical-align: top;
  line-height: 60px;
}
.user-info {
  text-align: right;
}
.yellowzi {
  color: #e3a720;
  margin-right: 5px;
}
/* .weixins {
  display: inline-block;
  text-align: right;
  position: absolute;
  right: 20px;
  top: 10px;
}
.weixins .weixin {
  display: inline-block;
  width: 60px;
  height: 60px;
}
.weixins .weixin img {
  width: 100%;
  height: 100%;
}
.weixins .addkefu {
  display: inline-block;
  line-height: 28px;
  vertical-align: top;
  padding: 0 5px;
} */
.tels {
  display: inline-block;
  text-align: right;
  position: absolute;
  right: 20px;
  top: 25px;
}
.tels .teltu {
  display: inline-block;
  width: 35px;
  height: 35px;
}
.tels .teltu img {
  width: 100%;
  height: 100%;
}
.tels .tel {
  display: inline-block;
  line-height: 28px;
  vertical-align: top;
  padding: 0 5px;font-weight: bold;font-size: 22px;color: #0b5394;
}
.img_box {
  padding: 10px 0 30px 0;
}
@media screen and (max-width: 1500px) {
  .logo .name {
    font-size: 16px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/Header.vue